export const profile = {
  name: 'Amir Khalifa',
  email: 'amir.kh28@hotmail.com',
  phone: '+972546773232',
  phoneDisplay: '054-677-3232',
  location: 'Tel Aviv, Israel',
  resume: '/Amir-Khalifa-Resume.pdf',
  github: 'https://github.com/amirkhalifa285',
  linkedin: 'https://www.linkedin.com/in/amir-khalifa-598a76239/',
};
